import { elakay_API } from "../../config";
import {getElakayLang, isAuthenticated  } from "../auth";
import {decryptData}  from '../auth/elakayCryptage'


 const { token } = isAuthenticated();
export const AddTraductoTeam = (token, teamTraductor, up) => {
    return fetch(`${elakay_API}/language/AddTraductoTeam?upd=${up}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(teamTraductor)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const allLanguageElakay = async (t) => { 
    try{
   const response = await  fetch(`${elakay_API}/language/allLanguageElakay?t=${t}`, {
        method: "GET"
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayById = async (token, ID) => { 
      try{
   const response = await  fetch(`${elakay_API}/language/LanguageElakayById/${ID}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayByLanguage = async (info, t) => { 
  
    const token_userAdding = localStorage.getItem("token_userAdding");

      try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayByLanguage?t=${t}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            AuthorizationUserAdding: `Bearer ${token_userAdding}`
        },
        body: JSON.stringify(info)
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayByTUID = async (token, lang, fam) => { 
    try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayByTUID?lang=${lang}&fam=${fam}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayBySUID = async (token) => { 
      try{
   const response = await fetch(`${elakay_API}/language/LanguageElakayBySUID`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const LanguageElakayByAUID = async (token) => { 
     try{
   const response = await  fetch(`${elakay_API}/language/LanguageElakayByAUID`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageElakay = async (ID, token, languageInfo) => { 
  try{
   const response = await  fetch(`${elakay_API}/language/updateLanguageElakay/${ID}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(languageInfo)
    })
        // Vérifie si le statut est une erreur HTTP

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
 const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageElakay0 = async (ID, token, languageInfo, coding) => {
     try{
   const response = await  fetch(`${elakay_API}/language/updateLanguageElakay0/${ID}?coding=${coding}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(languageInfo)
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
   const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const deleteLanguageElakay0 = async (ID, IDP, KEY, token, IV, coding = false) => {

      try{
   const response = await  fetch(`${elakay_API}/language/deleteLanguageElakay0/${ID}/${IDP}/${KEY}?I_V=${IV}&coding=${coding}`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const updateLanguageFileUp = async (ID, IDP, KEY, token, language, IV, coding= false) => {
    let languageInfo = new FormData()
    languageInfo.append('file', language)
      try{
   const response = await  fetch(`${elakay_API}/language/updateLanguageFileUp/${ID}/${IDP}/${KEY}?I_V=${IV}&coding=${coding}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: languageInfo
    })
        // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    
  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};

export const SelectDataEmaail = (array, title, value) => {
 try { 
    let objt = array.find(objt => objt.data.title === title)
    if (!objt) {
        throw new Error('no data found in elakay data base language');
      }
    return objt

} catch (err) {
     console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
}
};